import { ApplicationConfig, inject, provideZoneChangeDetection } from '@angular/core';
import { MessageService } from 'primeng/api';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

//Firebase
import { getAuth, provideAuth } from '@angular/fire/auth';

import { routes } from './app.routes';

import { providePrimeNG } from 'primeng/config';
import MyPreset from './mypreset';

// Interceptor
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { initializeApp, provideFirebaseApp, FirebaseApp } from '@angular/fire/app';

import { AuthStore } from './core/store/auth.store';

// NOTA: `firebaseConfig` (identity) queda desactivado; el login y toda la app usan solo `firebaseConfigDev`.
import { /* firebaseConfig, */ firebaseConfigDev } from 'src/app/environments/environment';

// Injection tokens for dev Firebase (se mantienen por compatibilidad; ya no se inyectan en el service)
import { DEV_FIREBASE_APP, DEV_FIREBASE_AUTH } from './core/tokens/auth.tokens';
import { getStorage, provideStorage } from '@angular/fire/storage';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withInterceptors([
        authInterceptor
      ])
    ),
    // --- Firebase Identity (nonprod/prod) DESACTIVADO ---
    // provideFirebaseApp(() => initializeApp(firebaseConfig)),
    // provideAuth(() => getAuth()),

    // Firebase Dev (csol-conectados-*): única app activa. Se registra como app por defecto
    // para que `inject(Auth)` (AuthStore, guards, etc.) apunte a este entorno.
    provideFirebaseApp(() => initializeApp(firebaseConfigDev)),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage()),

    // --- Providers secundarios para la app "dev" DESACTIVADOS ---
    // Ya no se necesitan: la app default es la dev.
    // {
    //   provide: DEV_FIREBASE_APP,
    //   useValue: initializeApp(firebaseConfigDev, 'dev')
    // },
    // {
    //   provide: DEV_FIREBASE_AUTH,
    //   useFactory: () => getAuth(inject(DEV_FIREBASE_APP))
    // },
    MessageService,
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: 'none',
        }
      },
      translation: {
        // ... tus filtros existentes
        dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
        // IMPORTANTE: Estos son los que aparecen en la cabecera del calendario
        dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
        monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
        today: 'Hoy',
        clear: 'Limpiar',
        weekHeader: 'Sem',
        firstDayOfWeek: 1, // 1 para que la semana empiece en Lunes
        accept: 'Aceptar',
        reject: 'Cancelar',
        emptyMessage: 'No se encontraron resultados',
        startsWith: 'Comienza con',
        contains: 'Contiene',
        notContains: 'No contiene',
        endsWith: 'Termina con',
        equals: 'Igual a',
        notEquals: 'Diferente de',
        noFilter: 'Sin filtro',
        lt: 'Menor que',
        lte: 'Menor o igual que',
        gt: 'Mayor que',
        gte: 'Mayor o igual que',
        is: 'Es',
        isNot: 'No es',
        before: 'Antes',
        after: 'Después',
        dateIs: 'Fecha es',
        dateIsNot: 'Fecha no es',
        dateBefore: 'Fecha antes',
        dateAfter: 'Fecha después',
        apply: 'Aplicar',
        matchAll: 'Coincidir con todos',
        matchAny: 'Coincidir con cualquiera',
        addRule: 'Agregar regla',
        removeRule: 'Eliminar regla',
        choose: 'Elegir',
        upload: 'Subir',
        cancel: 'Cancelar',
      }
    }),
  ]
};
